import APIService from './APIService';

export default {
  listar() {
    return APIService.apiCall().get('/identificacoes-ilhas-redes/listar');
  },
  executar(id) {
    return APIService.apiCall().post(`/identificacoes-ilhas-redes/executar/${id}`);
  },
  deletar(id) {
    return APIService.apiCall().post(`/identificacoes-ilhas-redes/excluir/${id}`);
  },
  save(postData) {
    return APIService.apiCall().post('/identificacoes-ilhas-redes/salvar', JSON.stringify(postData));
  },
  baixarLogsTecnicos(id) {
    return APIService.apiCall().get(`/identificacoes-ilhas-redes/logs-tecnicos/${id}`, {
      responseType: 'blob',
      ...{
        timeout: 60 * 60 * 1000
      }
    });
  },
  baixarArquivoResultado(id) {
    return APIService.apiCall().get(`/identificacoes-ilhas-redes/download-arquivo-resultado/${id}`, {
      responseType: 'blob',
      ...{
        timeout: 60 * 60 * 1000
      }
    });
  }
};
